export const BookingPath: string = '/:slug';
export const IntakeFormPath: string = '/:slug/intake-form';
export const FormPath: string = '/:slug/forms_invitation/:token';
